<template>
    <v-container>
        <v-dialog
            v-model="dialog"
            persistent
            width="300"
            v-if="dialog"
        >
            <v-card class="text-center my-3 elevation-0">
            <v-card-text>
                <p class="py-2">Cargando</p>
                <v-progress-linear
                    indeterminate
                    color="black"
                    class="mb-0"
                ></v-progress-linear>
            </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
export default {
    name: 'Loader',
    props: ['showLoader'],
    data() {
        return {
            dialog: this.showLoader
        }
    },
    watch: {
        showLoader(val) {
            console.log('Loading')
            this.dialog = val
        }
    }
}
</script>

<style>

</style>